"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingSessionClassification = exports.SummarizeModel = exports.SummarizeAction = exports.RolloverType = exports.Day = void 0;
var Day;
(function (Day) {
    Day[Day["Sun"] = 0] = "Sun";
    Day[Day["Mon"] = 1] = "Mon";
    Day[Day["Tue"] = 2] = "Tue";
    Day[Day["Wed"] = 3] = "Wed";
    Day[Day["Thu"] = 4] = "Thu";
    Day[Day["Fri"] = 5] = "Fri";
    Day[Day["Sat"] = 6] = "Sat";
})(Day || (exports.Day = Day = {}));
var RolloverType;
(function (RolloverType) {
    RolloverType[RolloverType["Today"] = 0] = "Today";
    RolloverType[RolloverType["Yesterday"] = 1] = "Yesterday";
    RolloverType[RolloverType["Tomorrow"] = 2] = "Tomorrow";
})(RolloverType || (exports.RolloverType = RolloverType = {}));
var SummarizeAction;
(function (SummarizeAction) {
    SummarizeAction[SummarizeAction["ExcludeFromIntraDay"] = 0] = "ExcludeFromIntraDay";
    SummarizeAction[SummarizeAction["ExcludeFromInterDay"] = 1] = "ExcludeFromInterDay";
    SummarizeAction[SummarizeAction["ExcludeIntraDayAndInterDay"] = 2] = "ExcludeIntraDayAndInterDay";
})(SummarizeAction || (exports.SummarizeAction = SummarizeAction = {}));
var SummarizeModel;
(function (SummarizeModel) {
    SummarizeModel[SummarizeModel["Rollover"] = 0] = "Rollover";
    SummarizeModel[SummarizeModel["Session"] = 1] = "Session";
})(SummarizeModel || (exports.SummarizeModel = SummarizeModel = {}));
var TradingSessionClassification;
(function (TradingSessionClassification) {
    TradingSessionClassification[TradingSessionClassification["Pre"] = 0] = "Pre";
    TradingSessionClassification[TradingSessionClassification["Normal"] = 1] = "Normal";
    TradingSessionClassification[TradingSessionClassification["Post"] = 2] = "Post";
})(TradingSessionClassification || (exports.TradingSessionClassification = TradingSessionClassification = {}));
